export enum Status {
  NEW = 0,
  SUBMITTED = 1,
  REVIEW = 2,
  INCOMPLETE = 3,
  INVALID = 4,
  DELETED = 5,
}
